var publicPath = __webpack_public_path__;
                    var symbolUrl = 'svg/icons.svg#shut-down';
                    var viewUrl = 'svg/icons.svg#view-shut-down';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 24 24',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };